import { useEffect } from 'react';
import { useFloating, autoUpdate } from '@floating-ui/react';
import { createPortal } from 'react-dom';
import { getDefaultNode } from 'foundations-components/transitional/utils/RootNode';
import { NEPTUNE_LAYER } from 'foundations-components/transitional/constants';
import { jsx as _jsx } from "react/jsx-runtime";
function SimpleFloaty({
  target,
  placement,
  middleware = [],
  children,
  'data-test-id': dataTestId,
  refreshKey
}) {
  var _middlewareData$hide, _middlewareData$hide2;
  const {
    refs,
    floatingStyles,
    middlewareData
  } = useFloating({
    whileElementsMounted: autoUpdate,
    placement,
    middleware
  });
  useEffect(() => {
    refs.setReference(target);
  }, [refs, target]);

  // Check if any middleware wants to hide the floaty
  // Used for custom hide logic
  const shouldHideFromCustomMiddleware = Object.values(middlewareData).some(data => (data === null || data === void 0 ? void 0 : data.shouldHide) === true);
  return /*#__PURE__*/createPortal( /*#__PURE__*/_jsx("div", {
    ref: refs.setFloating,
    "data-test-id": dataTestId,
    "data-tinymce-floating-element": "true",
    style: Object.assign({}, floatingStyles, {
      zIndex: NEPTUNE_LAYER,
      visibility: (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide.referenceHidden || (_middlewareData$hide2 = middlewareData.hide) !== null && _middlewareData$hide2 !== void 0 && _middlewareData$hide2.escaped || shouldHideFromCustomMiddleware ? 'hidden' : 'visible'
    }),
    children: children
  }, refreshKey), getDefaultNode());
}
export default SimpleFloaty;